module.exports = __webpack_public_path__ + "static/media/SW_BG_sky.ac9d844e.svg";